const POSITIONS = {
  "Goal Shooter": "GS",
  "Goal Attack": "GA",
  "Wing Attack": "WA",
  Centre: "C",
  "Wing Defence": "WD",
  "Goal Defence": "GD",
  "Goal Keeper": "GK",
};

const POSITIONS_SORT = {
  "Goal Shooter": 7,
  "Goal Attack": 6,
  "Wing Attack": 5,
  Centre: 4,
  "Wing Defence": 3,
  "Goal Defence": 2,
  "Goal Keeper": 1,
};
const CLOCK_COLOUR_PATH =
  "IMAGE*__SKY_SPORTS/TEAM_ELEMENTS/UNIVERSAL/TEAM_COLOURS/";

export class Formation {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
    vizSharedMemory,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.vizSharedMemory = vizSharedMemory;
    this.name = "Formation";
    this.scene = "Formation";
    this.data = [];
    this.page = 42;
  }

  async preview({ options }) {
    this.onAir = false;
    let lineup = [];
    let stats = [];

    let badge = "";
    if (options.game?.home_team._id === options.team._id) {
      lineup = options.game?.lineup?.home;
      stats = options.game?.home_player_stats;

      badge = options.game?.home_team?.variables?.badge || "";
      this.page = 42;
    } else if (options.game?.away_team._id === options.team._id) {
      lineup = options.game?.lineup?.away;
      stats = options.game?.away_player_stats;
      badge = options.game?.away_team?.variables?.badge || "";
      this.page = 44;
    }

    let xml = await this.getVizPage({ page: this.page }).catch((err) => {
      console.log(err);
    });

    if (xml) {
      xml.payload.field.find((item) => {
        return item.attr.name === "4005"; // Number
      }).value = options?.manager?.player?.title;

      xml.payload.field.find((item) => {
        return item.attr.name === "401"; // Number
      }).value = options?.manager?.player?.first_name;

      xml.payload.field.find((item) => {
        return item.attr.name === "402"; // Number
      }).value = options?.manager?.player?.last_name;

      xml.payload.field.find((item) => {
        return item.attr.name === "400"; // Number
      }).value = badge;

      xml.payload.field.find((item) => {
        return item.attr.name === "005"; // Number
      }).value = options.team?.name || "";

      xml.payload.field.find((item) => {
        return item.attr.name === "003"; // Number
      }).value = options.team?.variables?.[options.kit + "_kit_image"] || "";

      xml.payload.field.find((item) => {
        return item.attr.name === "004"; // Number
      }).value =
        CLOCK_COLOUR_PATH +
          options.team?.variables?.[options.kit + "_clock_text"] || "";

      lineup
        ?.filter((p) => p.order <= 7)
        ?.sort((a, b) => {
          let stat_a = stats?.find((p) => p.squad_id === a?.squad?._id);
          let stat_b = stats?.find((p) => p.squad_id === b?.squad?._id);
          return (
            POSITIONS_SORT[stat_a?.position] - POSITIONS_SORT[stat_b?.position]
          );
        })
        .forEach((player, index) => {
          let row = "0" + (index + 1);

          let stat = stats?.find((p) => p.squad_id === player?.squad?._id);
          try {
            xml.payload.field.find((item) => {
              return item.attr.name === row + "1"; // Number
            }).value = POSITIONS[stat?.position] || "";
            xml.payload.field.find((item) => {
              return item.attr.name === row + "2"; // Number
            }).value =
              player?.squad?.player?.first_name +
                " " +
                player?.squad?.player?.last_name || "";

            xml.payload.field.find((item) => {
              return item.attr.name === row + "3"; // Number
            }).value =
              options.team?.variables?.player_image_directory +
                "/" +
                (player?.squad?.player?.image ||
                  player?.squad?.player?.first_name +
                    "_" +
                    player?.squad?.player?.last_name) || "";
          } catch (err) {}
        });

      //subs
      xml.payload.field.find((item) => {
        return item.attr.name === "00003"; // Number
      }).value = lineup?.filter((p) => p.order > 7)?.length;

      lineup
        ?.filter((p) => p.order > 7)
        ?.forEach((player, index) => {
          let row = index + 1;
          try {
            xml.payload.field.find((item) => {
              return item.attr.name === "6" + row + "2"; // Number
            }).value = player?.squad?.player?.last_name || "";
          } catch (err) {}
        });

      await this.updateVizPage({
        page: this.page,
        data: xml,
        escape: false,
      }).catch((err) => {
        console.log(err);
      });

      await this.sendPreview("page:read " + this.page);
    }
  }
  animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.page });
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff({ page: this.page });
  }
}
